import { greekMessages } from '@/plugins/yup-localization';
import { BaseSchemaBuilder } from '@/views/checkouts/schemas/baseSchema';
import { isValidDate } from '@/views/checkouts/schemas/validators';
import * as yup from 'yup';

export const sharedAtlantikiFields = (
  firstDriverAdditionalPremiumAge,
  secondDriverAdditionalPremiumAge,
  firstDriverAdditionalPremiumLicenseYears,
  secondDriverAdditionalPremiumLicenseYears,
  legalEntity,
  secondDriver,
  discountEntity,
  vehicleType
) => {
  let schema = {
    ...BaseSchemaBuilder(true, false, legalEntity, !legalEntity, discountEntity),
    license_plate: yup.string().required(),
  };

  if (firstDriverAdditionalPremiumLicenseYears) {
    schema = {
      ...schema,
      licenseIssueDate: yup.object({
        day: yup.string().required(),
        month: yup.string().required(),
        year: yup.string().required(),
      }).test('isValidDate', greekMessages.mixed.isValidDate, isValidDate).required(),
    };
  }

  if (secondDriverAdditionalPremiumLicenseYears) {
    schema = {
      ...schema,
      licenseIssueDate2: yup.object().when('only_driver', {
        is: false,
        then: s => s.shape({
          day: yup.string().required(),
          month: yup.string().required(),
          year: yup.string().required(),
        }).test('isValidDate', greekMessages.mixed.isValidDate, isValidDate),
      }),
    };
  }

  return schema;
};


export const sharedAtlantikiSchemaBuilder = (...args) => yup.object(sharedAtlantikiFields(...args));
export default sharedAtlantikiSchemaBuilder;
